import { render, staticRenderFns } from "./ContactBanned.vue?vue&type=template&id=a3b31e46&"
import script from "./ContactBanned.vue?vue&type=script&lang=js&"
export * from "./ContactBanned.vue?vue&type=script&lang=js&"
import style0 from "./ContactBanned.vue?vue&type=style&index=0&id=a3b31e46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports